var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonSkOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.817,
    height: 23.224,
    viewBox: "0 0 21.817 23.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26922",
    "data-name": "Group 26922",
    transform: "translate(-11701.86 -4744.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26921",
    "data-name": "Group 26921",
    transform: "translate(14723.736 2463.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_793",
    "data-name": "Ellipse 793",
    transform: "translate(-3021.876 2281.124)",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.146,
    cy: 9.146,
    r: 9.146,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.146,
    cy: 9.146,
    r: 8.146,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3104",
    "data-name": "Line 3104",
    x2: 5.764,
    y2: 5.967,
    transform: "translate(-3007.237 2296.967)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3794",
    "data-name": "Line 3794",
    x2: 7,
    transform: "translate(11707.5 4750.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3795",
    "data-name": "Line 3795",
    x2: 10,
    transform: "translate(11706 4753.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3796",
    "data-name": "Line 3796",
    x2: 7,
    transform: "translate(11707.5 4756.5)",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonSkOrder);
export default __webpack_public_path__ + "static/media/Ikon_SökOrder.2b4265ace2808468673501753903744d.svg";
export { ForwardRef as ReactComponent };